var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-confirm',{attrs:{"confirm-title":"product.delete_product","description":_vm.description,"loading":_vm.loading,"contentHTML":_vm.contentHTML},on:{"confirm":function($event){return _vm.$emit('confirmDelete')},"cancel":() => {_vm.$emit('closeModal')}}},[_c('icon-delete',{attrs:{"size":100}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }